import { css, StarsIcon, styled, UploadIcon } from 'canoe';
import React from 'react';

import { Flags, useFlags } from 'commons/hooks';

import { GenerateImage } from './GenerateImage';
import { MediaUpload } from './MediaUpload';

const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.colors.GlitterGrayL20};
    flex: 0.4;
    flex-direction: column;
    display: flex;
    height: calc(100vh - 200px);
    padding: ${theme.spaces.s};
  `}
`;

const Inline = styled.div`
  display: flex;
  width: 100%;
`;

interface ButtonProps {
  isActive: boolean;
}

const ActionButton = styled.button<ButtonProps>`
  ${({ isActive, theme }) => css`
    align-items: center;
    background: transparent;
    border: none;
    border-bottom: 2px solid ${!isActive ? theme.colors.OnyxGrayL10 : theme.colors.BrandPurple};
    color: ${!isActive ? theme.colors.OnyxGrayL10 : theme.colors.BrandPurple};
    cursor: pointer;
    display: flex;
    font-size: ${theme.fonts.body.fontSize};
    justify-content: center;
    height: 42px;
    width: 100%;

    &:hover {
      text-decoration: none;
    }

    &:hover,
    &:focus {
      outline: none;
    }
  `}
`;

interface Props {
  isAiMode: boolean;
  toggleAiMode: (isOpen: boolean) => void;
}

export const MediaToolbox = ({ isAiMode, toggleAiMode }: Props) => {
  const {
    [Flags.FIRST_MATE]: withFirstMate,
    [Flags.FIRST_MATE_IMAGE_GENERATION]: withImageGeneration,
  } = useFlags();

  return (
    <Wrapper>
      {withFirstMate && withImageGeneration && (
        <Inline>
          <ActionButton onClick={() => toggleAiMode(false)} isActive={!isAiMode}>
            <UploadIcon marginRight="xxs" color={isAiMode ? 'OnyxGrayL10' : 'BrandPurple'} />
            Upload
          </ActionButton>
          <ActionButton onClick={() => toggleAiMode(true)} isActive={isAiMode}>
            <StarsIcon marginRight="xxs" color={!isAiMode ? 'OnyxGrayL10' : 'BrandPurple'} />
            Generate
          </ActionButton>
        </Inline>
      )}
      {!isAiMode && <MediaUpload />}
      {isAiMode && <GenerateImage />}
    </Wrapper>
  );
};
